export class UnexpectedImageStateError extends Error {
	constructor(message: string, public unexpectedImageState: any) {
		super(message);
	}
}

export function isUnexpectedImageStateError(error: UnexpectedImageStateError): error is UnexpectedImageStateError {
	return error.unexpectedImageState !== undefined;
}
